import { Routes, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { authGuard } from './auth/auth';


// ==========================================================
// Guard Mobile WebView
// ==========================================================
// ==========================================================
// Guard Mobile WebView (Nomes Blindados contra Duplicação)
// ==========================================================
export const mobileWebViewGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const isBrowser = typeof globalThis.window !== 'undefined';

  if (!isBrowser) {
    return true;
  }

  // 1. Se o canal do Flutter não existir na janela, assume na hora que é Web normal (Redireciona)
  const isFlutterEnv = !!(globalThis.window as any).Flutter;
  if (!isFlutterEnv) {
    return router.createUrlTree(['/recadastramento'], { queryParams: route.queryParams });
  }

  // 2. Coleta os parâmetros usando nomes exclusivos (Evita erro de re-declaração)
  const guardParams = new URLSearchParams(globalThis.window.location.search);

  let guardMobileToken = (globalThis.window as any).mobileToken ||
    (globalThis.window as any).flutter_token_value ||
    guardParams.get('token') ||
    sessionStorage.getItem('flutter_token');

  if (guardMobileToken) {
    return true;
  }

  // 3. Se for ambiente Flutter mas o token ainda não chegou, criamos uma Promise que aguarda a injeção
  return new Promise<boolean | ReturnType<typeof router.createUrlTree>>((resolve) => {

    // Criamos a função global que o Flutter vai invocar
    (globalThis.window as any).setFlutterCredentials = (token: string) => {
      sessionStorage.setItem('flutter_token', token);
      sessionStorage.setItem('auth_token', token);
      (globalThis.window as any).mobileToken = token;

      resolve(true); // Libera a rota raiz original do Mobile!
    };

    // Avisa o Flutter através do canal que o Guard do Angular está pronto aguardando o token
    try {
      (globalThis.window as any).Flutter.postMessage(JSON.stringify({ action: 'angular_ready' }));
    } catch (e) {
      console.error('[Guard] Erro ao enviar postMessage para o Flutter', e);
      resolve(router.createUrlTree(['/recadastramento'], { queryParams: route.queryParams })); // Fallback em caso de erro
    }

    // Timeout de segurança de 2 segundos: se o Flutter sumir, não deixa a tela travada em branco
    setTimeout(() => {
      if (!(globalThis.window as any).mobileToken) {
        console.warn('[Guard] Timeout atingido esperando o Flutter. Redirecionando para Web...');
        resolve(router.createUrlTree(['/recadastramento'], { queryParams: route.queryParams }));
      }
    }, 2000);
  });
};



// ==========================================================
// Rotas
// ==========================================================
export const routes: Routes = [

  {
    path: '',
    pathMatch: 'full',

    // Mobile usa token
    canActivate: [mobileWebViewGuard],

    loadComponent: () => import('./features/recadastramento/recadastramento')
      .then(c => c.Recadastramento),
  },


  {
    path: 'recadastramento',
    // Web normal usa Keycloak
    canActivate: [authGuard],
    loadComponent: () => import('./features/recadastramento/recadastramento')
      .then(c => c.Recadastramento),
  },


  {
    path: 'otp',
    canActivate: [authGuard],
    loadComponent: () => import('./features/otp/otp-validation')
      .then(c => c.OtpValidation),
  },


  {
    path: 'sucesso',
    canActivate: [authGuard],
    loadComponent: () => import('./features/cadastro-confirmado/cadastro-confirmado')
      .then(c => c.CadastroConfirmado),
  },

  {
    path: '**',
    redirectTo: ''
  }

];
